import {
  Box,
  Text,
  Button,
  Flex,
  Select
} from "@chakra-ui/react";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { useSurvey } from "./BusinessSurveyContext";


export default function BusinessSurveyIndustrySelection() {
  const navigate = useNavigate();
  const { surveyData, updateSurveyData } = useSurvey();
  const {industry} = surveyData || {};

  
  


  const industryOptions = [
    "Agriculture",
    "Mining",
    "Forestry",
    "Fishing",
    "Manufacturing",
    "Construction",
    "Retail",
    "Wholesale",
    "Hospitality",
    "Transportation",
    "Information and Communication",
    "Finance and Insurance",
    "Real Estate",
    "Professional Services",
    "Scientific and Technical Services",
    "Administrative and Support Services",
    "Education",
    "Healthcare",
    "Art, Entertainment, Recreation",
    "Other"
  ];


  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black" letterSpacing="wide">
          RESOURCES
        </Text>
      </Box>

      {/* Responsive Main Content */}
      <Box
        flex="1"
        display="flex"
        justifyContent="center"
        px={4}
        py={6}
        overflowY="auto"
      >
        <Box width="100%" maxW="420px">
          {/* Back Arrow */}

          {/* Survey Title */}
          <Text fontWeight="bold" fontSize="xl" color="black" mb={2} textAlign={"center"}>
            Pilot Small Business Assistance Application Survey
          </Text>


          {/* Custom Progress Bar */}
          <Box
            width="100%"
            maxW="360px"
            mx="auto"
            mb={10}
            height="28px"
            border="2px solid black"
            borderRadius="full"
            overflow="hidden"
          >
            <Box
              width="32%"
              height="100%"
              bg="#00C49A"
              borderRightRadius="full"
            />
          </Box>

          {/* Question */}
          <Text
            fontWeight="bold"
            fontSize="lg"
            mb={6}
            textAlign="left"
            px={2}
            textDecoration="none"
          >
            Industry
          </Text>

          {/* Dropdown Menu */}
          <Box mt={6} textAlign="center">
            <Select
              placeholder="Select..."
              variant="filled"
              bg="#E0E0E0"
              _focus={{
                boxShadow: "none",
                bg: "#E0E0E0",
                borderBottom: "2px solid #00C49A",
              }}
              borderBottom="2px solid #00C49A"
              borderRadius="md"
              fontStyle="italic"
              value={industry || ''}
              onChange={(e) => updateSurveyData({ industry: e.target.value })}
              maxW="400px"
              mx="auto"
            >
              {industryOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
          </Box>
        </Box>
      </Box>

      {/* Footer Navigation Buttons */}
      <Flex
        justifyContent="space-between"
        align="center"
        px={6}
        position="absolute"
        bottom="80px"
        width="100%"
      >
        <Button
          variant="ghost"
          leftIcon={<FaArrowLeft color="#00C49A" />}
          color="black"
          onClick={() => navigate("/business-app-1")}
        >
          Back
        </Button>
        <Button
          variant="ghost"
          onClick={() => {
            if (!industry) {
              alert("Please select an industry.");
              return;
            }
            navigate("/business-app-3");}}
          rightIcon={<FaArrowRight color="#00C49A" />}
          color="black"
        >
          Next
        </Button>
      </Flex>

      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      >
      </Flex>
    </Box>
  );
}
